import { createContext } from 'react';

const SelectionContext = createContext({})

export default SelectionContext;